import { TemplateRef } from '@angular/core'
import { Observable, Subject } from 'rxjs'

export enum HoverType {
  Normal = 0,
  Active = 1,
  Error = 2,
}

export interface IBaseInfoColumn {
  label: string // label
  /**
   * I18N key of the label
   */
  labelI18n?: string
  index?: string // key, å½ operate ä¸º true æ¶ï¼index ä¸éè¦ä¼ 
  value?: string | boolean | number | string[] // éææ¾ç¤ºå¼
  asyncValue?: Observable<string> // å¼æ­¥éææ¾ç¤ºå¼
  type?: string // ç¨ç§ç±»æ¥å¤æ­æ¥æ
  span: number // å®½åº¦å¼ï¼æ»å± 24, æ¯æ¬¡è°ç¨èªå·±å»ç®å¥½ï¼è¿ä¸ªç»ä»¶ä¸åèªå¨æçå¸å±ï¼å ä¸ºæåµå¤ªå¤äº
  color?: string // todo
  operate?: boolean // æ¯å¦æ¯æä½åå®¹ï¼å¦æ true, å index æ æ //see whether i can use this key to control the display and edit template
  template?: TemplateRef<any>
  displayTemplate?: TemplateRef<any> // éç¼è¾ç¶æä¸çtemplate
  hover?: HoverType
  id?: number
  disEditable?: boolean // ä¸å¯ç¼è¾
  asyncDisEditable?: Subject<boolean> // å¼æ­¥ä¸å¯ç¼è¾
  pipe?: (any) => any // èªå®ä¹è§£ææ°æ®æ¹æ³
  displayValue?: string // ç¨äºçº¯å±ç¤ºæ°æ®,å value ä¸åçæ¯, displayValue ä¸ä¼åä¸æ°å¼çä¼ é, æ¯å¦ååºæ¥ä¼ å°åç«¯å»,å®åªä¼çº¯å±ç¤º.
  validator?: {
    funcs?: any[],
    errorTips?: string[],
    isError?: boolean,
    currentErrorTip?: string

  }// ç¼è¾æ¶çå­æ®µæ ¡éª
  acl?: string[] // æéæ§å¶ï¼å¯ä»¥è®¾ç½®ä¸ç»æéå¼
  aclMode?: 'allOf' | 'oneOf'
  diff?: boolean // diff æ å¿ï¼å¨ä»»å¡ä¸­ï¼æ´æ°æä½ä¼ä½¿ç¨
}

export interface IBizInfoRow {
  img?: string
  title: string
  columns: IBaseInfoColumn[]
}
